// @mui
import {
	Alert,
	Box,
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Grid,
	TextField,
} from "@mui/material";
import { useState } from "react";
import { post } from "src/utils/networkUtils";

// ----------------------------------------------------------------------

const defaultConnectionData = {
	user: "",
	password: "",
	name: "",
	server: "",
};
export default function ConnectionMigrateDialog(props) {
	const { title, description, apiEndpoint, entityName } = props;

	const [connectionData, setConnectionData] = useState(defaultConnectionData);
	const [loading, setLoading] = useState(false);
	const [showResult, setShowResult] = useState(false);
	const [migrationResult, setMigrationResult] = useState(null);

	const handleChange = (e) => {
		const { id, value } = e.target;
		setConnectionData((prevState) => ({
			...prevState,
			[id]: value,
		}));
	};

	const onSuccess = async () => {
		setLoading(true);
		try {
			const response = await post(apiEndpoint, connectionData);
			setLoading(false);
			setMigrationResult(response.totalUpdated);
			setShowResult(true);
		} catch (error) {
			setLoading(false);
			console.log("error", error);
		}
	};
	const onCancel = () => {
		props.onClose();
	};

	const handleResultClose = () => {
		setShowResult(false);
		setMigrationResult(null);
		props.onClose();
	};

	return (
		<>
			<Dialog open={props.open} onClose={props.onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
				<DialogTitle id="alert-dialog-title">{title}</DialogTitle>
				<DialogContentText sx={{ px: 3 }}>{description}</DialogContentText>
				<DialogContent>
					{loading ? (
						<Box sx={{ display: "flex", justifyContent: "center" }} style={{ padding: 20 }}>
							<CircularProgress />
						</Box>
					) : (
						<Grid container>
							<Grid item xs={6} sx={{ m: 0, p: 1 }}>
								<TextField id="user" label="DB Username" fullWidth value={connectionData.user} variant="standard" onChange={handleChange} />
							</Grid>
							<Grid item xs={6} sx={{ m: 0, p: 1 }}>
								<TextField
									id="password"
									label="DB Password"
									fullWidth
									value={connectionData.password}
									variant="standard"
									onChange={handleChange}
								/>
							</Grid>

							<Grid item xs={6} sx={{ m: 0, p: 1 }}>
								<TextField id="name" label="DB Name" fullWidth value={connectionData.name} variant="standard" onChange={handleChange} />
							</Grid>

							<Grid item xs={6} sx={{ m: 0, p: 1 }}>
								<TextField
									id="server"
									label="DB Server"
									fullWidth
									value={connectionData.server}
									variant="standard"
									onChange={handleChange}
								/>
							</Grid>
						</Grid>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={() => onCancel()}>Cancel</Button>
					<Button onClick={() => onSuccess()} autoFocus disabled={loading}>
						Migrate
					</Button>
				</DialogActions>
			</Dialog>

			<Dialog open={showResult} onClose={handleResultClose} aria-labelledby="result-dialog-title">
				<DialogTitle id="result-dialog-title">Migration Complete</DialogTitle>
				<DialogContent>
					<Alert severity="success" sx={{ mt: 1 }}>
						Successfully migrated {migrationResult} {entityName}.
					</Alert>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleResultClose} autoFocus>
						OK
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}
